export default {"src":"/_next/static/media/boxes_middle_for_dark_themes.72c33012.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};